import { useEffect, useState, useCallback, useRef } from 'react'
import { browserHistory } from 'react-router'
import { connect } from 'react-redux'
import { TrackingHOC } from 'hocs'
import { selectQuery } from '../App/selectors'
import SuggestContainer from './SuggestContainer'
import { fetchSuggestions } from './actions'
import SearchForm from 'components/Subheader/Form'

function SearchInput(props) {
  const [search, setSearch] = useState('')

  useEffect(() => {
    const query = props.query.q
    if (query && query.trim() !== '') {
      setSearch(query)
    }
  }, [props.query.q])

  const trackSearch = useCallback(
    (query, action) => {
      props.createEvent &&
        props.createEvent({
          category: 'search',
          data: { action, search_term: query }
        })
    },
    [props.createEvent]
  )

  const debounceRef = useRef()
  const onInputChange = (e, { newValue, method }) => {
    setSearch(newValue)
    if (debounceRef.current) {
      clearTimeout(debounceRef.current)
    }
    if (newValue && method === 'type' && newValue.trim().length > 1) {
      debounceRef.current = setTimeout(() => {
        props.fetchSuggestions && props.fetchSuggestions(newValue)
        trackSearch(newValue, 'revise')
      }, 300) // 300ms debounce
    }
  }

  const handleSubmit = e => {
    e.preventDefault()
    if (search.trim() !== '') {
      trackSearch(search, 'submit')
      browserHistory.push(`/v2/search?q=${encodeURIComponent(search)}`)
      // Remove focus from search input to hide suggestions
      document.activeElement.blur()
    }
  }

  const handleSelect = (event, { suggestion }) => {
    setSearch(suggestion)
    trackSearch(suggestion, 'select_suggestion')
    browserHistory.push(`/v2/search?q=${encodeURIComponent(suggestion)}`)
    // Optionally, clear debounce to avoid firing after click
    if (debounceRef.current) {
      clearTimeout(debounceRef.current)
    }
  }

  const handleClear = () => {
    setSearch('')
  }

  const suggestionProps = {
    ...props,
    search,
    onChange: onInputChange,
    value: search,
    handleSelect,
    handleClear
  }

  return (
    <SearchForm onSubmit={handleSubmit}>
      <SuggestContainer {...suggestionProps} />
    </SearchForm>
  )
}

const mapStateToProps = state => ({
  query: selectQuery(state),
  ...state.search,
  suggestions: state?.osearch?.suggestions
})

const mapDispatchToProps = dispatch => ({
  fetchSuggestions: query => dispatch(fetchSuggestions.request(query))
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(TrackingHOC(SearchInput))
